import { autoReminderModalCampaign } from './auto-reminder-modal/auto-reminder-modal.campaign'
// import { feedbackSurveyModalCampaign } from './feedback-survey-modal/feedback-survey-modal.campaign'
// import { g2CapterraReviewModalCampaign } from './g2-capterra-review-modal/g2-capterra-review-modal.campaign'
// import { installChromeExtensionModalCampaign } from './install-chrome-extension-modal/install-chrome-extension-modal.campaign'
import { kalamaRenamedModalCampaign } from './kalama-renamed-modal/kalama-renamed-modal.campaign'
import { kalamaTeaserModalCampaign } from './kalama-teaser-modal/kalama-teaser-modal.campaign'
import { pausedRemindersModalCampaign } from './paused-reminders-modal/paused-reminders-modal.campaign'
import { subscriptionEndedModalCampaign } from './paused-reminders-modal/subscription-ended-modal.campaign'
import { typeformReviewModalCampaign } from './typeform-review-modal/typeform-review-modal.campaign'
import { shopifyWordpressSurveyModalCampaign } from './shopify-wordpress-survey-modal/shopify-wordpress-survey-modal.campaign'
import { setAndForgetPromoModalCampaign } from './set-and-forget-promo-modal/set-and-forget-promo-modal.campaign'

export const alertCampaigns = [
  pausedRemindersModalCampaign,
  subscriptionEndedModalCampaign,
  kalamaTeaserModalCampaign,
  kalamaRenamedModalCampaign,
  // installChromeExtensionModalCampaign,
  autoReminderModalCampaign,
  setAndForgetPromoModalCampaign,
  // feedbackSurveyModalCampaign,
  // g2CapterraReviewModalCampaign,
  typeformReviewModalCampaign,
  shopifyWordpressSurveyModalCampaign,
].sort((left, right) => left.priority - right.priority)
